var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.generateUrl}},[_vm._v("跳转测试223332")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }